import React from 'react'
import { NavItem } from '../../../interfaces/Navigation.Interface'
import he from 'he'
import Advertisement from '../header/advertisments/Advertisment'

const NavMenuItem = (item: NavItem) => {
  return (
    <li>
      <a href={item.absolute}>{he.decode(item.title)}</a>
      {item.items == null ? (
        ''
      ) : (
        <ul>
          {item.items.map((subItem: NavItem, index) => {
            return <NavMenuItem key={index} {...subItem} />
          })}
        </ul>
      )}
      {item.advertisement == null ? (
        ''
      ) : (
        <Advertisement {...item.advertisement} />
      )}
    </li>
  )
}

export default NavMenuItem
